export default "__VITE_ASSET__8992ab3a__"